<template>
  <div class="empty-state-wrap" :class="{centerstate: contentCenter}">
    <div class="empty-state--image"><slot name="image" /></div>
    <div class="empty-state--contentwrap">
      <div class="empty-state--title"><slot name="title" /></div>
      <div class="empty-state--content"><slot name="content" /></div>
      <div class="empty-state--cta"><slot name="cta" /></div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: {
    contentCenter: {
      type: Boolean,
      default: false
    },
  },
}
</script>

<style lang="scss">
.empty-state-wrap {
  &.emptystate-simple {
    justify-content: center !important;
    align-items: center;
    text-align: center;
  }
}
</style>
  
<style lang="scss" scoped>
.empty-state-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 2rem;
  @media(min-width: '768px') {
    flex-direction: row;
    justify-content: flex-start;
    padding: 4rem;
  }
  &.centerstate {
    justify-content: center;
    padding: 0rem;
    .empty-state--image {
      height: 100%;
      display: flex;
      align-items: center;
      z-index: 0; 
      width: 100%;
      position: absolute;
      top: 0;
      left: 0px;
      opacity: 0.1;
      img {
        width: 100%;
      }
    }
  }
  .empty-state {
    &--contentwrap {
      display: flex;
      flex-direction: column;
      max-width: 400px;
      z-index: 10;
    }
    &--image {
      width: 100%;
      img { width: 100%; }
      text-align: center;
      margin-bottom: 2rem;
      @media(min-width: '576px') {
        img { min-width: 135px;}
      }
      @media(min-width: '768px') {
        width: auto;
        margin-bottom: 0rem;
        margin-right: 2rem;
      }
    }
    &--title {
      font-size: 20px;
      font-family: DINNextLTPro-Medium, sans-serif;
      margin-bottom: 0.5rem;
      @media(min-width: '768px') {
        font-size: 22px;
      }
    }
    &--content {
      text-align: left;
      font-size: 16px;
      margin-bottom: 1.5rem;
      color: $colorUnassigned;
    }
    &--cta {
      display: flex;
      flex-direction: column;
      > .btn { width: 100%; margin-bottom: 0.5rem; }
      @media(min-width: '768px') {
        flex-direction: row;
        > .btn { width: auto; margin-bottom: 0rem; margin-right: 0.5rem; }
      }
    }
  }
}
</style>
